export enum BlazeDeviceQueryKey {
  CREATE_FIRMWARE = 'createFirmware',
  DELETE_DEVICE_ACCESS_KEY = 'deleteDeviceAccessKey',
  DELETE_DEVICE_CLAIM = 'deleteDeviceClaim',
  DELETE_FIRMWARE = 'deleteFirmware',
  DEVICE = 'device',
  DOWNLOAD_FIRMWARE = 'downloadFirmware',
  EXPORT_DATA = 'exportData',
  GET_DEVICE_UPDATER = 'getDeviceUpdater',
  LIST_DEVICE_ACCESS_KEYS = 'listDeviceAccessKeys',
  LIST_DEVICE_CLAIMS = 'listDeviceClaims',
  LIST_DEVICE_STATES = 'ListDeviceStates',
  LIST_DEVICES = 'listDevices',
  LIST_DEVICES_REVOCATIONS = 'listDevicesRevocations',
  LIST_FIRMWARES = 'listFirmwares',
  LIST_NOTIFICATIONS = 'listNotifications',
  PATCH_FIRMWARE = 'patchFirmware',
  RELEASE_FIRMWARE_GA = 'releaseFirmwareGA',
  RESET_DEVICE = 'resetDevice',
  SEND_SENTIO_BROKER_CONFIG = 'sendSentioBrokerConfig',
  SEND_DEVICE_CONFIG = 'sendDeviceConfig',
  SET_DEVICE_RELEASE_MODE = 'setDeviceReleaseMode',
  START_DEVICE_UPDATER = 'startDeviceUpdater',
  UPDATE_FIRMWARE = 'updateFirmware',
}

export enum IgniteUserQueryKey {
  USER = 'user',
  USER_BY_EMAIL = 'userByEmail',
  DELETE_USER = 'deleteUser',
  PATCH_USER = 'patchUser',
  LIST_USERS = 'listUsers',
  USER_ROLES = 'userRoles',
}

export enum KleosQueryKey {
  LIST_MY_GLOBAL_PERMISSIONS = 'listMyGlobalPermissions',
  SET_GLOBAL_PERMISSION = 'setGlobalPermission',
  MY_DEVICE_PERMISSIONS = 'myDevicePermissions',
}
